import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const binApi = createApi({
  reducerPath: "binApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://nodejs-bin-it-to-win-it.vercel.app/api/v1/bins",
  }),

  endpoints: (builder) => ({
    getBins: builder.query({
      query: (filter) => ({
        url: `?${filter}`,
      }),
    }),
    getAllBinsInArea: builder.query({
      query: (id) => `?area=${id}`,
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: "Bin", id })),
              { type: "Bin", id: "LIST" },
            ]
          : [{ type: "Bin", id: "LIST" }],
    }),
  }),
});

export const { useGetBinsQuery, useGetAllBinsInAreaQuery } = binApi;
